import React, { useCallback } from 'react';
import FEHeaderProps from './props';
import { IMG_PLACEHOLDER_LOGO } from 'images';
import style from './style.module.css';
import { FEBar } from 'components';
import { Confirmation, Menu } from './components';
import { useTranslation } from 'react-i18next';
import { DesktopCartButton } from 'pages/catalogDesktop/components';
import StartAppConfirmation from './components/startAppConfirmation';
import { SavedAddressesPicker } from 'pages/cartography/layouts/savedAddressesPicker';

const FEHeader = ({
  orderType,
  address,
  restaurant,
  onAddressBarClick,
  onLogoClick,
  onCloseConfirmation,
  onDeclineConfirmation,
  isOpenConfirmation,
  isOpenStartAppConfirmation,
  isOpenAddressPicker,
  onCloseAddressPicker,
  onAddAddress,
  onAddressPickerEmpty,
}: FEHeaderProps) => {
  const { t } = useTranslation();
  const [logoWidth, setLogoWidth] = React.useState<number>(0);

  const logoRefCallback = useCallback((node: HTMLElement | null) => {
    if (node) {
      const width = node.getBoundingClientRect().width;
      setLogoWidth(width);
    } else {
      setLogoWidth(0);
    }
  }, []);

  return (
    <div className={style.header}>
      <div className={style.container}>
        <div className={style.appData}>
          <img
            ref={logoRefCallback}
            className={style.logo}
            src={IMG_PLACEHOLDER_LOGO}
            alt=''
            onClick={onLogoClick}
          />
          <div
            className={style.addressContainer}
            style={{
              width: `calc(100% - ${logoWidth}px)`,
            }}
          >
            <FEBar
              onClick={onAddressBarClick}
              label={
                orderType === 'COURIER'
                  ? t('cartography.header.deliveryLabel')
                  : t('cartography.header.pickupLabel')
              }
              value={orderType === 'COURIER' ? address : restaurant}
              placeholder={t('cartography.header.placeholder')}
              isOpenStartAppConfirmation={isOpenStartAppConfirmation}
            />
            <Confirmation
              value={orderType === 'COURIER' ? address : restaurant}
              open={isOpenConfirmation}
              onClose={onCloseConfirmation}
              onDeclineConfirmation={onDeclineConfirmation}
            />
            <StartAppConfirmation
              value={orderType === 'COURIER' ? address : restaurant}
              open={isOpenStartAppConfirmation}
              onClose={onCloseConfirmation}
              onDeclineConfirmation={onDeclineConfirmation}
            />
            <SavedAddressesPicker
              open={isOpenAddressPicker}
              onClose={onCloseAddressPicker}
              onAddAddress={onAddAddress}
              onEmpty={onAddressPickerEmpty}
            />
          </div>
        </div>
        <div className={style.headerButtonsContainer}>
          <div className={style.userData}>
            <Menu />
          </div>
          <DesktopCartButton />
        </div>
      </div>
    </div>
  );
};

export default FEHeader;
export type { FEHeaderProps };
